import { SyntheticEvent, useEffect, useState } from "react"
import { Box } from "@mui/system"
import { useFormikContext } from "formik"
import { Tab, Tabs } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { useAppLocalization } from "../../../../../localization/components/AppLocalizationProvider"
import { TabPanel } from "../../../../../../shared/components/tabs/tabPanel"
import { FormShopContentSettings } from "../FormShopContentSettings"
import { FormShopContentGeneral } from "../FormShopContentGeneral"
import { CreateOrEditShopFormValues } from "../../shopsTypes"

const useStyles = makeStyles()(() => ({
    content: {
        width: "100%",
    },
    tabsWrap: {
        borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
        marginBottom: "2rem",
    },
    tab: {
        textTransform: "none",
    },
}))

const tabIndex = {
    general: 0,
    settings: 1,
}

export const TabsForm = () => {
    const { classes } = useStyles()
    const { l10n } = useAppLocalization()

    const [activeTab, setActiveTab] = useState(tabIndex.general)

    const handleTabChange = (event: SyntheticEvent, newActiveTab: number) => {
        setActiveTab(newActiveTab)
    }

    const { errors, isSubmitting } = useFormikContext<CreateOrEditShopFormValues>()

    useEffect(() => {
        if (errors.name || errors.type) {
            setActiveTab(tabIndex.general)
        }
    }, [errors, isSubmitting])

    return (
        <Box className={classes.content}>
            <Box className={classes.tabsWrap}>
                <Tabs value={activeTab} onChange={handleTabChange}>
                    <Tab
                        value={tabIndex.general}
                        label={l10n.getString("merchant-create-edit-shop-tab-general")}
                        wrapped
                        className={classes.tab}
                    />
                    <Tab
                        value={tabIndex.settings}
                        label={l10n.getString("merchant-create-edit-shop-tab-settings")}
                        wrapped
                        className={classes.tab}
                    />
                </Tabs>
            </Box>
            <TabPanel value={activeTab} index={tabIndex.general}>
                <FormShopContentGeneral />
            </TabPanel>
            <TabPanel value={activeTab} index={tabIndex.settings}>
                <FormShopContentSettings />
            </TabPanel>
        </Box>
    )
}
